import React from 'react';

import { colors } from '../../components';

interface ChatBGProps extends React.SVGProps<SVGSVGElement> {
    bubbleColor?: string;
}

const ChatBG = ({ bubbleColor, ...props }: ChatBGProps) => (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M43.9999 22C43.9999 34.1503 34.1503 44 21.9999 44C17.9124 44 14.0849 42.8854 10.8058 40.9432C8.66455 41.9096 6.36932 42.5376 4.03393 42.7895C3.25509 42.8733 2.67497 42.0887 2.97811 41.3663C3.69921 39.6492 4.29172 37.4306 4.59453 35.4567C1.71399 31.7369 0 27.0685 0 22C0 9.84968 9.84962 0 22 0C34.1504 0 44 9.84962 44 22H43.9999Z"
            fill={bubbleColor || colors.bluePreset[10]}
        />
    </svg>
);

export default ChatBG;
